import { AT } from "../global/actionTypes";
import { Club } from "../types/types";

export const putClubs = (clubs: Club[]) => ({
  type: AT.PUT_CLUBS,
  payload: clubs,
});

export const fetchClubs = () => ({ type: AT.FETCH_CLUBS });
